module.exports = __webpack_public_path__ + "img/united-states.36ab476e.svg";